import {
  setGuideDeliberatePractice,
  setGuideDeliberatePractices,
} from "reduxStore/state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getGuideDeliberatePractices = () => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/guideDeliberatePractice`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to get guides");
    }

    const guides = await response.json();

    dispatch(setGuideDeliberatePractices(guides));
    return guides;
  } catch (error) {
    console.error("Error while getting guides:", error);
    return null;
  }
};

export const getGuideDeliberatePracticeById =
  (id) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(
        `${BASE_URL}/guideDeliberatePractice/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to get guide");
      }

      const guide = await response.json();

      dispatch(setGuideDeliberatePractice(guide));
      return guide;
    } catch (error) {
      console.error("Error while getting guide:", error);
      return null;
    }
  };

export const createGuideDeliberatePractice =
  (guide) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(`${BASE_URL}/guideDeliberatePractice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(guide),
      });

      if (!response.ok) {
        throw new Error("Failed to create guide");
      }

      const createdGuide = await response.json();

      dispatch(setGuideDeliberatePractice(createdGuide));
      dispatch(getGuideDeliberatePractices());

      return createdGuide;
    } catch (error) {
      console.error("Error while creating guide:", error);
      return null;
    }
  };

export const updateGuideDeliberatePractice =
  (guide) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(
        `${BASE_URL}/guideDeliberatePractice/${guide._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(guide),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update guide");
      }

      const updatedGuide = await response.json();

      dispatch(setGuideDeliberatePractice(updatedGuide));
      return updatedGuide;
    } catch (error) {
      console.error("Error while updating guide:", error);
      return null;
    }
  };

export const deleteGuideDeliberatePractice =
  (id) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(
        `${BASE_URL}/guideDeliberatePractice/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete guide");
      }

      dispatch(getGuideDeliberatePractices());
      return true;
    } catch (error) {
      console.error("Error while deleting guide:", error);
      return false;
    }
  };
